///// <reference path="../../types.d.ts"/>

import * as React from "react";
import "./style.scss";

import Section from "../../../core/Section";
import Table from "../../../core/Table";
import Feature from "../../../common/components/Feature";
import { ConfirmationModal } from "../../../core/Modal";
import Button from "../../../core/Button";
import SendNowPopover from "./SendNowPopover";

import { Icon, Popover } from "antd";

import { Report, ReportFile } from "../../constants";
import { ViewReportProps, ViewReportActions } from "./container";

import { NavLink, withRouter } from "react-router-dom";

const REPORT_COLUMNS = [
  {
    title: "Status",
    dataIndex: "enabled",
    key: "enabled",
    sorter: (a: Report, b: Report) =>
      a.enabled === b.enabled ? 0 : a.enabled === "Enabled" ? -1 : 1,
    width: 75
  },
  {
    title: " Name",
    dataIndex: "name",
    key: "name",
    sorter: (a: ReportFile, b: ReportFile) => a.name.localeCompare(b.name)
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    sorter: (a: ReportFile, b: ReportFile) =>
      a.description.localeCompare(b.description)
  },
  {
    title: "Edit Destinations",
    dataIndex: "endpoints_link",
    key: "endpoint_link",
    width: 110
  },
  {
    title: "Edit Report",
    dataIndex: "edit_link",
    key: "edit_link",
    width: 100
  },
  {
    title: (
      <div>
        Send Latest&nbsp;&nbsp;&nbsp;
        <Popover content={SendNowPopover} trigger="hover">
          <Icon type="question-circle" />
        </Popover>
      </div>
    ),
    dataIndex: "send_latest_link",
    key: "send_latest_link",
    width: 125
  },
  {
    dataIndex: "delete_button",
    key: "delete_button",
    width: 100
  }
];

interface ViewReportsState {
  modalReport: Report;
}

class ViewReports extends React.Component<
  ViewReportProps & ViewReportActions,
  ViewReportsState
> {
  constructor() {
    super();
    this.state = {
      modalReport: null
    };
  }

  componentWillMount() {
    this.props.flushReports();
    this.props.getReports(this.props.match.params.merchant_id);
  }

  deleteReport() {
    let report = this.state.modalReport;
    if (report) {
      this.props.deleteReport(
        this.props.match.params.merchant_id,
        report.id,
        report.name
      );
    }
    this.closeDeleteReportModal();
  }

  openDeleteReportModal(report: Report) {
    this.setState({ modalReport: report });
  }

  closeDeleteReportModal() {
    this.setState({ modalReport: null });
  }

  sendLatestReport(report: Report) {
    let merchant_id = this.props.match.params.merchant_id;
    this.props.sendLatestReport(merchant_id, report.id);
  }

  mapsToTableRows() {
    let merchant_id = this.props.match.params.merchant_id;
    return this.props.reports.map((report: Report) => {
      return {
        key: report.id,
        name: report.name,
        description: report.description,
        enabled: report.enabled ? "Enabled" : "Disabled",
        endpoints_link: (
          <NavLink
            to={{
              pathname: `/merchants/${merchant_id}/reports/${report.id}/edit`,
              state: { step: 2 }
            }}
          >
            {" "}
            Edit{" "}
          </NavLink>
        ),
        edit_link: (
          <NavLink
            to={{
              pathname: `/merchants/${merchant_id}/reports/${report.id}/edit`,
              state: { step: 1 }
            }}
          >
            {" "}
            Edit
          </NavLink>
        ),

        // Disabled due to issues sending / downloading reports
        send_latest_link: (
          <Feature flag="apr_3_admin">
            <Button
              className="ant-btn-secondary"
              onClick={this.sendLatestReport.bind(this, report)}
            >
              Send Now
            </Button>
          </Feature>
        ),
        delete_button: (
          <Button
            className="ant-btn-secondary ant-btn-danger"
            onClick={this.openDeleteReportModal.bind(this, report)}
          >
            Delete
          </Button>
        )
      };
    });
  }

  render() {
    let reportName = this.state.modalReport ? this.state.modalReport.name : "";
    return (
      <div className="view-report-templates">
        <h1>View Reports</h1>
        <Table
          size="middle"
          dataSource={this.mapsToTableRows()}
          columns={REPORT_COLUMNS}
        />

        <ConfirmationModal
          className="ant-confirm-body delete-modal"
          titleText={`Are you sure you want to delete ${reportName} ?`}
          bodyText="Deleting this template will not affect any existing report files. No further files will be generated based on this report template."
          primaryButtonText="Delete"
          secondaryButtonText="Close"
          onPrimaryButton={this.deleteReport.bind(this)}
          onSecondaryButton={this.closeDeleteReportModal.bind(this)}
          visible={null != this.state.modalReport}
        />
      </div>
    );
  }
}

export default withRouter(ViewReports as any);



// WEBPACK FOOTER //
// ./client/modules/Report/components/ViewReports/component.tsx